import { CollaboratorService } from "../../core/http/service/CollaboratorService";
import { DependentesService } from "../../core/http/service/DependentesService";
import { AppStorage } from "../../storage/AppStorage";

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const uploadCsvColaborador = (arquivo: any, id: string) => {
  return async () => {
    const service: CollaboratorService = new CollaboratorService();
    try {
      
      const body = new FormData();
      body.append("file", arquivo[0]);

      const response = await service.upload(body, id);
      return response;

    } catch (error: any) {
      sendToAnalytics(error);
      return error;

    }
  };
};

export const uploadCsvDependente = (arquivo: any, id: string) => {
  return async () => {
    const service: DependentesService = new DependentesService();
    try {

      const body = new FormData();
      body.append("file", arquivo[0]);

      const response = await service.upload(body, id);
      return response;

    } catch (error: any) {
      sendToAnalytics(error);
      return error;

    }
  };
};